import { useEffect } from 'react';

/**
 * Custom hook to set page title and favicon dynamically
 * @param {string} title - The page title to display in browser tab
 * @param {string} faviconPath - Path to the favicon SVG file
 */
export const usePageMeta = (title, faviconPath) => {
  useEffect(() => {
    // Set document title
    const previousTitle = document.title;
    document.title = title;

    // Set favicon
    let link = document.querySelector("link[rel~='icon']");
    const previousFavicon = link?.href;
    
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.type = 'image/svg+xml';
    link.href = faviconPath;

    // Cleanup: restore previous title and favicon when component unmounts
    return () => {
      document.title = previousTitle || 'Harmony Apps';
      if (link && previousFavicon) {
        link.href = previousFavicon;
      }
    };
  }, [title, faviconPath]);
};

// Pre-defined configurations for each sub-app
export const PAGE_META = {
  EXPENSE_MANAGER: {
    title: 'Expense Manager | Harmony Apps',
    favicon: '/favicon-expense.svg'
  },
  ASSET_MANAGER: {
    title: 'Asset Manager | Harmony Apps',
    favicon: '/favicon-asset.svg'
  },
  RECRUITMENT_PORTAL: {
    title: 'Recruitment Portal | Harmony Apps',
    favicon: '/favicon-recruitment.svg'
  },
  MAIN_DASHBOARD: {
    title: 'Harmony Apps',
    favicon: '/favicon-harmony.svg'
  }
};

export default usePageMeta;
